import { apiFetch } from "./api";

export interface PermissionDto { key: string; group: string; label: string; description: string; }
export interface RolePermissionsDto { role: string; permissions: string[]; }

export const rolesAdminApi = {
  permissions: (): Promise<PermissionDto[]> => apiFetch<PermissionDto[]>("/api/admin/permissions"),
  roles: (): Promise<RolePermissionsDto[]> => apiFetch<RolePermissionsDto[]>("/api/admin/roles"),
  setPermissions: (role: string, permissions: string[]): Promise<void> =>
    apiFetch<void>(`/api/admin/roles/${encodeURIComponent(role)}/permissions`,
      { method: "PUT", body: JSON.stringify({ permissions }) }),
  reset: (role: string): Promise<void> =>
    apiFetch<void>(`/api/admin/roles/${encodeURIComponent(role)}/permissions/reset`, { method: "POST" }),
};
